var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCash({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.0096 9.53125C10.5001 9.53125 9.27637 10.755 9.27637 12.2646C9.27637 13.7742 10.5001 14.9979 12.0096 14.9979C13.5192 14.9979 14.743 13.7742 14.743 12.2646C14.743 10.755 13.5192 9.53125 12.0096 9.53125ZM10.5929 12.2646C10.5929 11.4822 11.2272 10.8478 12.0096 10.8478C12.7921 10.8478 13.4265 11.4822 13.4265 12.2646C13.4265 13.0471 12.7921 13.6814 12.0096 13.6814C11.2272 13.6814 10.5929 13.0471 10.5929 12.2646Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.68718 12.2718C6.68718 12.8361 6.2297 13.2936 5.66537 13.2936C5.10103 13.2936 4.64355 12.8361 4.64355 12.2718C4.64355 11.7075 5.10103 11.25 5.66537 11.25C6.2297 11.25 6.68718 11.7075 6.68718 12.2718Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3148 13.2936C18.8792 13.2936 19.3366 12.8361 19.3366 12.2718C19.3366 11.7075 18.8792 11.25 18.3148 11.25C17.7504 11.25 17.293 11.7075 17.293 12.2718C17.293 12.8361 17.7504 13.2936 18.3148 13.2936Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.6045 5H3.39504C2.32579 5 1.45898 5.8668 1.45898 6.93606V17.6059C1.45898 18.6751 2.32579 19.542 3.39504 19.542H20.6045C21.6737 19.542 22.5405 18.6751 22.5405 17.6059V6.93606C22.5405 5.8668 21.6738 5 20.6045 5ZM3.00783 6.93606C3.00783 6.72221 3.18119 6.54885 3.39504 6.54885H20.6045C20.8183 6.54885 20.9917 6.72221 20.9917 6.93606V17.6059C20.9917 17.8198 20.8183 17.9931 20.6045 17.9931H3.39504C3.18119 17.9931 3.00783 17.8198 3.00783 17.6059V6.93606Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCash);
export default __webpack_public_path__ + "static/media/cash.f5e3e13636551b700f3e6d5f41ae217c.svg";
export { ForwardRef as ReactComponent };